export enum LogLevel {
  DEBUG = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3,
  SILENT = 4,
}

export interface LogEntry {
  level: LogLevel;
  namespace: string;
  fileName?: string;
  message: string;
  data?: unknown;
  timestamp: Date;
  error?: Error;
  breadcrumbs?: Breadcrumb[];
}

export interface Breadcrumb {
  timestamp: Date;
  level: LogLevel;
  namespace: string;
  fileName?: string;
  message: string;
}

export interface Transport {
  log(entry: LogEntry): void;
  table?(data: unknown[], columns?: string[]): void;
}

export interface LoggerOptions {
  level?: LogLevel;
  transports?: Transport[];
  enabled?: boolean;
  historySize?: number;
  breadcrumbSize?: number;
  enabledNamespaces?: string[];
  disabledNamespaces?: string[];
  persistConfig?: boolean;
}

export const LEVEL_NAMES: Record<LogLevel, string> = {
  [LogLevel.DEBUG]: "DEBUG",
  [LogLevel.INFO]: "INFO",
  [LogLevel.WARN]: "WARN",
  [LogLevel.ERROR]: "ERROR",
  [LogLevel.SILENT]: "SILENT",
};

export const LEVEL_EMOJIS: Record<LogLevel, string> = {
  [LogLevel.DEBUG]: "🔍",
  [LogLevel.INFO]: "ℹ️",
  [LogLevel.WARN]: "⚠️",
  [LogLevel.ERROR]: "🔴",
  [LogLevel.SILENT]: "",
};
